import { render, staticRenderFns } from "./DownloadCOButton.vue?vue&type=template&id=080fefb8&scoped=true&"
import script from "./DownloadCOButton.vue?vue&type=script&lang=js&"
export * from "./DownloadCOButton.vue?vue&type=script&lang=js&"
import style0 from "./DownloadCOButton.vue?vue&type=style&index=0&id=080fefb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080fefb8",
  null
  
)

export default component.exports